import { ridSegment } from '@krp/client-runtime'

/** Адреса ставки НДС товаров 1С (`ProductEndpoints`, `/catalog/vat/*`). Литерал `/api/` — только здесь. */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}/catalog/vat`

export const ONEC_VAT_URLS = {
  summary: (resourceId: string) => `${base(resourceId)}/summary`,
  preview: (resourceId: string) => `${base(resourceId)}/preview`,
  apply: (resourceId: string) => `${base(resourceId)}/apply`,
} as const
